<div *ngIf="showMe">
    <tds-modal show="true" (tdsClose)="closeDialog(false)" header="CAFS user GDPR info" size="md">
        <span slot="body">
            <tds-text-field style="margin-top: 10px;"
                [(ngModel)]="userId"
                ngDefaultControl
                type="Text"
                size="lg"
                state="default"
                label="Enter user ID"
                label-position="inside"
                placeholder="Ex: SSSXXX">
            </tds-text-field>
        </span>

        <span slot="actions">
            <tds-button
                data-dismiss-modal
                type="button"
                variant="secondary"
                size="md"
                text="Cancel"
                (click)="closeDialog(false)">
            </tds-button>

            <tds-button style="margin-left: 15px;"
                data-dismiss-modal
                type="button"
                variant="primary"
                size="md"
                text="Get Data"
                (click)="closeDialog(true)">
            </tds-button>
        </span>
    </tds-modal>
</div>